import {RouterModule} from '@angular/router';

import {SelfEvaluationComponent} from './self-evaluation.component';
import {FeelingsRatingComponent} from './feelings-rating/feelings-rating.component';
import {FeelingsSelectionComponent} from './feelings-selection/feeling-selection.component';
import {SmokeDetectorComponent} from './smoke-detector/smoke-detector.component';
import {AmnesticFeelingSelectionComponent} from './amnestic-feeling-selection/amnestic-feeling-selection.component';
import {AmnesticSmokeDetectorComponent} from './amnestic-smoke-detector/amnestic-smoke-detector.component';
import {ContinueLaterComponent} from './continue-later/continue-later.component';
import { CircumstanceComponent } from './circumstance/circumstance.component';

export const SelfEvaluationRoutesModule = RouterModule.forChild([
    {
        path: '',
        component: SelfEvaluationComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        // path: 'feelings-rating',
        path: '3',
        component: FeelingsRatingComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        // path: 'feelings-selection',
        path: '2',
        component: FeelingsSelectionComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        // path: 'feelings-selection/:layer',
        path: '2/:layer',
        component: FeelingsSelectionComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        // path: 'smoke-detector',
        path: '1/circumstance',
        component: CircumstanceComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        // path: 'smoke-detector',
        path: '1',
        component: SmokeDetectorComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        // path: 'amnestic-feeling-selection',
        path: '4/2',
        component: AmnesticFeelingSelectionComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        path: '4',
        component: FeelingsRatingComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        path: '4/1',
        component: AmnesticSmokeDetectorComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        path: '5/2',
        component: AmnesticFeelingSelectionComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        // path: 'amnestic-smoke-detector',
        path: '5/1',
        component: AmnesticSmokeDetectorComponent,
        data: {
            class: 'se-page'
        }
    },
    {
        path: 'continue-later',
        component: ContinueLaterComponent,
        data: {
            class: 'se-page'
        }
    },
]);
